export default () => {
    if (!window.BigInt) {
        window.BigInt = Number;
    }
};
